// extracted by mini-css-extract-plugin
module.exports = {"name":"ThreadMessage_name__6QDz5","date":"ThreadMessage_date__tsuWm","component":"ThreadMessage_component__oRVML"};